module.exports = __webpack_public_path__ + "img/hair-toppers@2x.2faf1a3a.jpg";